import { FontIcon, mergeStyles } from 'office-ui-fabric-react';
import { Nav } from 'office-ui-fabric-react/lib/Nav';
import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import logo from "../assets/logo.png";
import ConnectionContext from '../utils/ConnectionContext';
import './NavMenu.css';

interface IProps {
    email: string;
    isAuthenticated: boolean;
    connectionContext: ConnectionContext;
}
interface IState {
    collapsed?: boolean;
    loggedOut: boolean;
}
const topPanel = mergeStyles({
    backgroundColor: '#C2D2D8'
});
const logoPanel = mergeStyles({
    margin: "0px 30px 0px 10px"
});
const titlePanel = mergeStyles({
    color: '#326974', fontSize: "16px"
});
const titlePanelLoggedIn = mergeStyles({
    color: '#326974', fontSize: "16px", width: "100%"
});
const iconPanel = mergeStyles({
    marginRight: "2px"
});
const navLink = mergeStyles({
    color: '#005269', marginRight: "5px"
});
const topMenu = mergeStyles({
    margin: '0px auto', float: 'right', paddingRight: "10px"
});
export class NavMenu extends React.Component<IProps, IState> {
    constructor(props: IProps, state: IState) {
        super(props);
        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            loggedOut: false
        };
    }
    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }
    private logout = async (): Promise<void> => {
        try {
            await this.props.connectionContext.logout();
            this.setState((prevState: IState): IState => {
                prevState.loggedOut = true;
                return prevState;
            });
        } catch (error) {
            console.log(error);
        }
    }
    public render(): React.ReactElement<IProps> {
        const { loggedOut } = this.state;
        if (loggedOut)
            return <Redirect to={'/User/Login/Login'} />;
        return (
            <div className={topPanel}>
                {
                    (this.props.isAuthenticated) &&
                    <header>
                        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-0" dark>
                            <NavbarBrand tag={Link} to="/" className={logoPanel}>
                                <a href="https://www.zacco.com" target="_blank" rel="noopener noreferrer" ><img src={logo} height="15" alt="" /></a>
                            </NavbarBrand>
                            <div className={titlePanelLoggedIn}>
                                Agent network
                            </div>
                            <div className={topMenu}>
                                <Nav
                                    ariaLabel="Click here to exit"
                                    styles={{
                                        root: {
                                            height: '40px',
                                            boxSizing: 'border-box',
                                            border: '1px solid #eee',
                                            overflowY: 'visible',
                                        },
                                        link: {
                                            backgroundColor: "#C2D2D8"
                                        }
                                    }}
                                    groups={[
                                        {
                                            links: [
                                                {
                                                    name: this.props.email.toUpperCase(),
                                                    url: '',
                                                    links: [
                                                        {
                                                            name: 'Logout',
                                                            onClick: this.logout,
                                                            url: "",
                                                            iconProps: { iconName: 'Signout' }
                                                        },
                                                    ],
                                                }
                                            ],
                                        },
                                    ]}
                                />
                            </div>
                        </Navbar>
                    </header>
                }
                {
                    (!this.props.isAuthenticated) &&
                    <header>
                        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-0" light>
                            <NavbarBrand tag={Link} to="/" className={logoPanel}>
                                <a href="https://www.zacco.com" target="_blank" rel="noopener noreferrer" ><img src={logo} height="15" alt="" /></a>
                            </NavbarBrand>
                            <div className={titlePanel}>
                                Agent network
                            </div>
                            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                                <ul className="navbar-nav flex-grow" >
                                    <li>
                                        <NavItem>
                                            <NavLink tag={Link} className={navLink} to="/"><FontIcon iconName="Home" className={iconPanel} />Home</NavLink>
                                        </NavItem>
                                    </li>
                                    <li>
                                        <NavItem>
                                            <NavLink tag={Link} className={navLink} to="/User/Register"><FontIcon iconName="JoinOnlineMeeting" className={iconPanel} />Register</NavLink>
                                        </NavItem>
                                    </li>
                                    <li>
                                        <NavItem>
                                            <NavLink tag={Link} className={navLink} to="/User/Login/Login"><FontIcon iconName="Signin" className={iconPanel} />Login</NavLink>
                                        </NavItem>
                                    </li>
                                </ul>
                            </Collapse>
                        </Navbar>
                    </header>
                }
            </div>
        );
    }
}